{
  "sidebar": {
    "administration": "Administration",
    "accessControl": "Access Control",
    "roles": "Roles",
    "permissions": "Permissions",
    "routes": "Routes",
    "users": "Users"
  },
  "common": {
    "loading": "Loading...",
    "saving": "Saving...",
    "saved": "Changes saved successfully.",
    "noResults": "No results found.",
    "error": "Something went wrong.",
    "retry": "Try again",
    "cancel": "Cancel",
    "save": "Save",
    "edit": "Edit",
    "delete": "Delete",
    "back": "Back",
    "confirm": "Confirm",
    "deleting": "Deleting..."
  },
  "roles": {
    "title": "Roles",
    "loading": "Loading roles...",
    "error": "Couldn't load roles right now.",
    "errorDescription": "This usually resolves quickly — give it another try.",
    "empty": "No custom roles yet.",
    "emptyAction": "Create Role",
    "emptyDescription": "Create your first custom role to define permissions beyond the built-in defaults.",
    "saved": "Role updated successfully.",
    "created": "Role created successfully.",
    "deleted": "Role deleted successfully.",
    "columns": {
      "name": "Name",
      "displayName": "Display Name",
      "priority": "Priority",
      "inheritsFrom": "Inherits From",
      "permissionCount": "Permissions",
      "isSystem": "System",
      "isDefault": "Default"
    },
    "badges": {
      "system": "System",
      "default": "Default"
    },
    "detail": {
      "title": "Role: {{name}}",
      "error": "Couldn't load this role.",
      "editMode": "Edit",
      "viewMode": "View",
      "edit": "Edit",
      "cancelEdit": "Cancel",
      "save": "Save Changes",
      "cancel": "Cancel",
      "delete": "Delete Role",
      "metadata": {
        "createdAt": "Created",
        "createdBy": "Created by",
        "updatedAt": "Updated",
        "updatedBy": "Updated by"
      },
      "permissions": {
        "title": "Permissions",
        "add": "Add Permission",
        "empty": "No permissions assigned",
        "inherited": "Inherited Permissions",
        "inheritedEmpty": "No inherited permissions"
      },
      "deleteDialog": {
        "title": "Delete Role",
        "message": "Are you sure you want to delete the role \"{{name}}\"? This action cannot be undone.",
        "confirm": "Delete",
        "cancel": "Cancel",
        "inUseError": "Cannot delete role: it is still assigned to users"
      },
      "metadataTitle": "Metadata",
      "auditTitle": "Audit",
      "systemWarning": "This is a system role. Only users with system:manage_admins can edit it.",
      "editing": "Editing",
      "unsavedChanges": "Unsaved changes",
      "unsavedConfirm": "You have unsaved changes. Discard them?",
      "noDescription": "No description"
    },
    "create": {
      "title": "Create Role",
      "action": "Create Role",
      "submit": "Create",
      "cancel": "Cancel"
    },
    "delete": {
      "title": "Delete Role",
      "confirm": "Delete the role \"{{name}}\"? Users assigned this role will lose its permissions. This can't be undone.",
      "action": "Delete Role",
      "cannotDelete": "This role cannot be deleted.",
      "systemDisabled": "System roles cannot be deleted"
    },
    "fields": {
      "name": "Role Name",
      "nameHint": "Letters, numbers, and underscores only (e.g. content_editor)",
      "displayName": "Display Name",
      "description": "Description",
      "priority": "Priority",
      "prioritySystemHint": "System role priority cannot be changed."
    }
  },
  "users": {
    "title": "Users",
    "loading": "Loading users...",
    "error": "Couldn't load the user list.",
    "errorDescription": "This usually resolves quickly — give it another try.",
    "empty": "No users match your filters.",
    "emptyAction": "Clear Filters",
    "emptyDescription": "Try broadening your search or removing some filters.",
    "columns": {
      "username": "Username",
      "displayName": "Display Name",
      "role": "Role",
      "status": "Status",
      "verified": "Verified",
      "lastLogin": "Last Login",
      "registered": "Registered"
    },
    "filters": {
      "search": "Search users...",
      "searchHelp": "Minimum 2 characters",
      "role": "Role",
      "excludeRole": "Exclude Role",
      "status": "Status",
      "registeredRange": "Registered",
      "lastLoginRange": "Last Login",
      "clearAll": "Clear Filters"
    },
    "detail": {
      "title": "User Details",
      "error": "Couldn't load this user.",
      "overview": "Overview",
      "permissions": "Permissions"
    },
    "permissions": {
      "title": "User Permissions",
      "editMode": "Edit Permissions",
      "role": "Role",
      "grants": "Scoped Grants",
      "restrictions": "Restrictions",
      "effective": "Effective Permissions",
      "permissions": "Permissions",
      "reason": "Reason",
      "reasonRequired": "A reason is required for permission changes.",
      "reasonTitle": "Reason for Changes",
      "reasonDescription": "Permission changes are logged with a reason for audit visibility.",
      "reasonPlaceholder": "Briefly describe why these changes are needed...",
      "save": "Save Permissions",
      "saved": "Permissions updated successfully.",
      "loading": "Loading permissions...",
      "grantsEmpty": "No additional grants.",
      "grantsEmptyDescription": "This user has only their role's default permissions. Add scoped grants to extend access.",
      "restrictionsEmpty": "No restrictions applied.",
      "restrictionsEmptyDescription": "Restrictions override role permissions for specific scopes."
    }
  },
  "permissions": {
    "title": "Permission Reference",
    "search": "Search permissions...",
    "reference": {
      "error": "Couldn't load the permission reference."
    },
    "searchEmpty": "No permissions match your search.",
    "searchEmptyDescription": "Try a different search term or clear the filter.",
    "namespace": "{{namespace}}",
    "count": "{{count}} permissions",
    "namespaces": {
      "game": "Game",
      "chat": "Chat",
      "user": "User",
      "social": "Social",
      "party": "Party",
      "auth": "Auth",
      "mod": "Moderation",
      "admin": "Admin",
      "system": "System"
    },
    "descriptions": {
      "game:read": "View game data and game-related details.",
      "game:play": "Join and play games.",
      "game:create_lobby": "Create game lobbies.",
      "game:join": "Join existing game sessions.",
      "chat:send": "Send chat messages.",
      "chat:read": "Read chat messages.",
      "user:read": "Read user profile data.",
      "user:write": "Modify user profile data.",
      "user:read_self": "Read your own profile.",
      "user:update_self": "Update your own profile.",
      "user:manage_permissions": "Manage user-specific permission grants and restrictions.",
      "social:read": "View social data.",
      "social:write": "Modify social data.",
      "social:friend_request": "Send friend requests.",
      "social:friend_accept": "Accept friend requests.",
      "party:use": "Use party features.",
      "auth:read_self": "Read your own authentication-related data.",
      "mod:warn": "Warn players or users.",
      "mod:mute": "Mute players or users.",
      "mod:kick": "Kick players from games or services.",
      "mod:view_reports": "View moderation reports.",
      "mod:close_reports": "Resolve or close moderation reports.",
      "admin:ban": "Ban users.",
      "admin:unban": "Remove user bans.",
      "admin:edit_user": "Edit user details.",
      "admin:list_users": "List users in the admin interface.",
      "admin:view_user": "View individual user details.",
      "admin:search_users": "Search for users in admin tools.",
      "admin:view_logs": "View administrative logs.",
      "admin:manage_games": "Manage games across the platform.",
      "admin:ws_connections": "Inspect WebSocket connections.",
      "admin:origin_rotate": "Trigger origin rotation operations.",
      "system:manage_roles": "Create, update, and delete roles.",
      "system:manage_admins": "Manage administrative users and system-level access.",
      "system:config": "Modify system configuration."
    }
  },
  "routes": {
    "title": "Route Permissions",
    "error": "Couldn't load route mappings.",
    "search": "Search by path...",
    "filterByService": "Filter by service",
    "allServices": "All Services",
    "searchEmpty": "No routes match your filters.",
    "searchEmptyDescription": "Try a different search term or service filter.",
    "columns": {
      "method": "Method",
      "path": "Path",
      "permission": "Permission",
      "service": "Service"
    }
  },
  "scope": {
    "global": "Global",
    "scoped": "Scoped",
    "gameIds": "Game IDs",
    "userIds": "User IDs",
    "regions": "Regions",
    "gameIdsPlaceholder": "Search games...",
    "userIdsPlaceholder": "Search users...",
    "regionsPlaceholder": "e.g. us-east-1, eu-west-1",
    "addScope": "Add Scope",
    "editScope": "Edit Scope",
    "clearScope": "Set Global",
    "apply": "Apply",
    "gameCount_one": "{{count}} game",
    "gameCount_other": "{{count}} games",
    "userCount_one": "{{count}} user",
    "userCount_other": "{{count}} users"
  },
  "forbidden": {
    "title": "Off Limits",
    "message": "You don't have the right permissions for this page. Talk to an admin if that doesn't seem right.",
    "action": "Back to Dashboard"
  },
  "errors": {
    "SELF_MODIFICATION": "You cannot modify your own permissions.",
    "PRIORITY_GUARD": "You cannot modify a user with equal or higher priority.",
    "ROLE_ASSIGNMENT": "You cannot assign a role with higher priority than your own.",
    "LAST_SUPER_ADMIN": "Cannot remove the last super admin.",
    "GRANT_RESTRICTION_CONFLICT": "This grant conflicts with an existing restriction.",
    "SYSTEM_ROLE_PROTECTED": "System roles cannot be deleted.",
    "ROLE_IN_USE": "This role is in use and cannot be deleted.",
    "INHERITANCE_CYCLE": "This would create a circular inheritance chain.",
    "ROLE_ALREADY_EXISTS": "A role with this name already exists.",
    "network": "A network error occurred. Please try again.",
    "loadFailed": "Failed to load data",
    "saveFailed": "Failed to save changes",
    "deleteFailed": "Failed to delete",
    "unauthorized": "You don't have permission to perform this action",
    "notFound": "The requested resource was not found"
  },
  "a11y": {
    "searchPermissions": "Search permissions",
    "searchResults": "{{count}} permissions in {{groups}} groups",
    "searchNoResults": "No permissions match your search",
    "namespaceGroup": "{{namespace}} ({{count}} permissions)",
    "rolePermissions": "Role permissions",
    "grantPermissions": "Grant permissions",
    "restrictionPermissions": "Restriction permissions"
  },
  "attribution": {
    "scopedGrant": "Scoped grant",
    "restriction": "Restriction",
    "contributedBy": "Contributed by: {{roles}}"
  }
}
